/**
 * @module domain/pledgeValidation
 * @description Pure validation for the pledge form. Returns field-keyed
 * messages so the UI can show them inline next to each field.
 */
import type { Pledge } from "./types";

export type PledgeDraft = Omit<Pledge, "id" | "createdAt">;
export type PledgeErrors = Partial<Record<keyof PledgeDraft, string>>;

export interface PledgeRules {
    /** Edition requires the Terms and Conditions box to be ticked. */
    requireTerms: boolean;
}

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Validates a pledge draft.
 * @returns An empty object when the draft is valid.
 */
export function validatePledge(draft: PledgeDraft, rules: PledgeRules = { requireTerms: false }): PledgeErrors {
    const errors: PledgeErrors = {};
    if (!Number.isFinite(draft.amount) || draft.amount < 1) errors.amount = "Choose or enter a gift amount.";
    if (!draft.name.trim()) errors.name = "Please add your name.";
    if (!EMAIL_PATTERN.test(draft.email.trim())) errors.email = "Please add a valid email for your receipt.";
    if (rules.requireTerms && !draft.agreedToTerms) errors.agreedToTerms = "Please agree to the Terms and Conditions.";
    return errors;
}
